// Shared labels for email_log rows shown to broker users (Configuración →
// Uso month detail, Configuración → Organización → Correos enviados).
// The portal Bandeja and the per-cliente Correos column keep their own
// client-facing wording.

export const EMAIL_TEMPLATE_LABELS = {
  'welcome-client': 'Bienvenida cliente',
  'welcome-team-member': 'Bienvenida equipo',
  'welcome-owner': 'Bienvenida administrador',
  'welcome-operator': 'Bienvenida operador',
  'acceso-cliente': 'Aviso de acceso',
  'solicitud-expediente': 'Solicitud de documentos',
  'fianza-emitida': 'Fianza emitida',
  'pendiente-solicitud': 'Solicitud de pendientes',
  'reparto-aprobacion': 'Aprobación de reparto',
  'resumen-pendientes': 'Resumen de pendientes',
  'resumen-falta': 'Lo que te falta',
  'resumen-negocio': 'Lo que pasó',
  'pendiente-asignado': 'Asignación de pendiente',
  'mass-campaign': 'Campaña',
};

export function labelForEmailRow(row) {
  if (row?.templateKey === 'solicitud-expediente' && row?.kind === 'recordatorio') {
    return 'Recordatorio de documentos';
  }
  return EMAIL_TEMPLATE_LABELS[row?.templateKey] || row?.subject || row?.templateKey || '—';
}
